import { getRedemptionError, PaywallDisplay, redeemPass, setDisplayState } from 'redux/slices/paywall'
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { useStyles } from './styles'
import { useAuth0, LoginAction } from 'libs/web-client/utils/auth0/src'

export enum AuthMethod {
    AUTH_METHOD_SIGNUP,
    AUTH_METHOD_SIGNIN,
    NONE,
}

const RedeemCode: React.FC = () => {
    const classes = useStyles()
    const [code, setCode] = useState('')
    const { isAuthenticated, loginWithPopup } = useAuth0()
    const redemptionError = useSelector(getRedemptionError)
    const dispatch = useDispatch()
    const handleLoginClick = useCallback(() => loginWithPopup({ action: LoginAction.LOGIN }), [loginWithPopup])
    const onSignUpSubmit = useCallback(() => loginWithPopup({ action: LoginAction.REGISTER }), [loginWithPopup])
    const onRedeemPass = useCallback(async () => {
        await dispatch(redeemPass(code.trim()))
        window.heap.track('User redeemed code')
    }, [dispatch, code])

    return (
        <div className={classes.container}>
            <h2 className={classes.paywallHeading}>
                <span>code redemption</span>
                <a
                    href="#/"
                    onClick={evt => {
                        evt.preventDefault()
                        dispatch(setDisplayState(PaywallDisplay.CHOOSE_PASS_TIER))
                    }}
                >
                    Need a code?
                </a>
            </h2>
            <p className={classes.paragraph}>Redeem your code to gain full access.</p>
            <SimpleInput
                error={redemptionError}
                value={code}
                onChange={e => setCode(e.target.value)}
                type="text"
                placeholder="Enter confirmation code"
                maxLength={20}
            />
            {isAuthenticated ? (
                <CallToActionButton
                    onClick={onRedeemPass}
                    type="secondary"
                    display="block"
                    text="redeem confirmation code"
                />
            ) : (
                <>
                    <p className={classes.paragraph}>
                        In order to redeem and gain access to the event, you’ll need to sign up for an account below.
                        The pass (and code) will automatically save to your account.
                    </p>
                    <CallToActionButton
                        onClick={onSignUpSubmit}
                        text="sign up for an account"
                        display="block"
                        type="secondary"
                        className={classes.signUpButton}
                        disabled={!code}
                        id="paywall-sign-up-submit-btn"
                    />

                    <p className={classes.paragraph}>
                        Already have an account?
                        <button className={classes.signInLink} onClick={handleLoginClick}>
                            Sign in to your account
                        </button>
                    </p>
                </>
            )}
        </div>
    )
}

export default RedeemCode
